export default {
  goose3_duck3: '青萍溫濕度計 / Lite',
  gd3_title: '青萍溫濕度計 / Lite',
  gd3_first_title: '精準測溫濕',
  gd3_screen: '顯示屏',
  gd3_range: '量程',
  gd3_e_ink: '電子墨水屏',
  gd3_segment_lcd: '段碼液晶屏',
  gd3_temp_label: '溫度：',
  gd3_humi_label: '濕度：',
  gd3_screen_label: '螢幕',
  gd3_goose_screen: '電子墨水屏，50 × 50 毫米',
  gd3_duck_screen: '段碼液晶屏，50 × 50 毫米',
  gd3_five_desc: '搭配米家藍牙網關設備，可設置青萍溫濕度計和青萍溫濕度計 Lite 與米家智慧設備的聯動，改善{br}室內溫濕度環境，讓家更舒適。 ',
}
